/**
 * Models a member's elegibility.
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    commercialPlanId: String,
    startDate: Date,
    endDate: Date,
  },
  defaults: {
    commercialPlanId: null,
    startDate: null,
    endDate: null,
  },
});

export { Model as default };
